import { FormState, LookupRequest, LookupType } from '../types';

/**
 * Converts a query-level request into form state components (identifier and lookup type).
 * Used for showing toasts in response to a completed request.
 */
export const getFormStateFromLookupRequest = (request: LookupRequest): FormState =>
  'email' in request
    ? { identifier: request.email, lookupType: LookupType.ByEmail }
    : { identifier: request.userId, lookupType: LookupType.ByUserId };
